"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;

var _permission = require("./permission");

var _group = require("./group");

class User {
  constructor() {
    this.id = void 0;
    this.email = void 0;
    this.fullName = void 0;
    this.isActive = void 0;
    this.createdAt = void 0;
    this.groups = [];
    this.permissions = new Map();
  }

  /**
   * Find if a user is Super Admin.
   *
   * @returns { boolean } - true is the user is super admin
   */
  isSuperAdmin() {
    return this.permissions.has('*');
  }
  /**
   * Find if a user has the given permission or not.
   * In case he or she is a super admin, return true
   *
   * @param { string } permission
   * @returns { boolean } - true is the user has permission
   */


  hasPermission(permission) {
    return this.isSuperAdmin() || this.permissions.has(permission);
  }
  /**
   * Find if a user has all the given permissions.
   * In case he or she is a super admin, return true immediately
   *
   * @param { ...string } permissions
   * @returns { boolean } - true is the user has permission
   */


  hasPermissions(...permissions) {
    return this.isSuperAdmin() || permissions.every(permission => this.permissions.has(permission));
  }
  /**
   * Transform a JSON into a User
   *
   * @param {Object.<string, any>} json
   * @returns {User}
   */


  static fromJson(json) {
    const user = new User();
    user.id = json.id;
    user.email = json.email;
    user.fullName = json.full_name;
    user.isActive = json.is_active;
    user.createdAt = new Date(json.created_at);
    user.groups = json.groups.map(g => _group.Group.fromJson(g));
    user.permissions = new Map(Object.entries(json.permissions).map(([key, value]) => [key, _permission.Permission.fromJson(value)]));
    return user;
  }

}

exports.User = User;